module.exports = __webpack_public_path__ + "img/wic.9e53693e.png";